import React from "react";
import { TSCard } from "@/components/shared/card/Card";
import strings from './tenantManagement.translations';

interface SaveModalProps {
  visible: boolean;
  tenantName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const SaveModal: React.FC<SaveModalProps> = ({
  visible,
  tenantName,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <TSCard className="p-6 w-[400px]">
        <h2 className="text-lg font-bold mb-4">{strings.saveModal.title}</h2>
        <p className="mb-6">
          {strings.saveModal.message(tenantName)}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            {strings.saveModal.cancel}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {strings.saveModal.confirm}
          </button>
        </div>
      </TSCard>
    </div>
  );
};